import { computed } from 'vue';
import { useNow } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { remainingParts } from '../helpers';

// Live "2 д 4 ч" style countdown to an ISO timestamp (refreshes every 30 s).
export function useCountdown(untilRef) {
  const { t } = useI18n();
  const now = useNow({ interval: 30000 });

  const parts = computed(() =>
    remainingParts(untilRef.value, now.value.getTime())
  );

  const label = computed(() => {
    const value = parts.value;
    if (!value) return '';
    if (value.days > 0) {
      return t('MULTICHAT.SOURCE.COUNTDOWN.DAYS_HOURS', {
        days: value.days,
        hours: value.hours,
      });
    }
    if (value.hours > 0) {
      return t('MULTICHAT.SOURCE.COUNTDOWN.HOURS_MINUTES', {
        hours: value.hours,
        minutes: value.minutes,
      });
    }
    return t('MULTICHAT.SOURCE.COUNTDOWN.MINUTES', { minutes: value.minutes });
  });

  const isExpired = computed(() => !!untilRef.value && !parts.value);

  return { parts, label, isExpired };
}
